import { isNgTemplate, ThrowStmt } from '@angular/compiler';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { linkTypeEnum } from 'src/app/models/enums';
import { rootModel } from 'src/app/models/rootModel';
import { slider, sliderModel } from 'src/app/models/slider';
import { DataService } from 'src/app/Services/data.service';


@Component({
  selector: 'app-slider',
  templateUrl: './slider.component.html',
  styleUrls: ['./slider.component.css']
})
export class SliderComponent implements OnInit {

  @Input() language: string;
  @Input() sliderClass: string;

  @Output() gelenAssigned = new EventEmitter<string>();

elinkTypeEnum = linkTypeEnum;



actifSliderUrl:string;
  rootModel:rootModel=new rootModel();
  sliders:slider[]=[];
  slider:slider = new slider();
  sliderModel:sliderModel = new sliderModel();
   sayi:number[]=[];
  constructor(private dataServices:DataService, private route:ActivatedRoute) {

    this.sliders = [];
   }



  ngOnInit(): void {   

    

    this.route.paramMap.subscribe(params=>{

      if(params.get("language"))
      this.rootModel.language  = params.get("language");  
      else
       this.rootModel.language='tr';

           this.getSliders(); 
    })

    //this.rootModel.language= this.language;


  }



  getSliders()
  {    
    this.sliders = [];

     this.dataServices.getSliders(this.rootModel).subscribe(p=>{
      this.sliderModel = p;
      this.sliderData(); 


     })

  }
  
 
  heightDeger(deger:string):string
  {
    if(deger==''){
      return '407';
    }
    return '360';
  }

  sliderImg(deger:string):string
  {
    if(deger==''){
      return 'sliderImgAnasayfa';
    }
    return 'sliderImg';
  }
  yuvarlakToplar(deger:string):string
  {
    if(deger=='')
    {
      return 'yuvarlakToplarAnasayfa';
    }
    return 'yuvarlakToplar';

  }

  activeClass(indexOfelement:number):string
  {   
    if(indexOfelement==0)
        {     return 'active'; }
    else{     return '';    }

  }
  getUrl()
  {
    this.gelenAssigned.emit("");
  }
  onEvent($event)
  { 
    const deger = $event;
  }

  sliderData()
  {      
   this.sayi = [];
   if( this.sliderModel.sliders)
   {
      for (let i = 0; i < this.sliderModel.sliders.length; i++) {  
        this.sayi.push(i); 
      //  this.sayi.push(i);              

    }  
   }       
    
  }
  

}
